import { createMemoStyles } from '@wds/utils';

import { PricingAppTheme } from '~app/styles/pricing/types';
import { SM_MEDIA_QUERY, MD_MEDIA_QUERY } from '~shared/media-query';

const useHubSpotStyles = createMemoStyles<string, {}, PricingAppTheme>(({ spacing }) => ({
  CheckBoxWrapper: {
    display: 'inline-grid',
    gridTemplateColumns: '1fr 12fr',
    '& div > p': {
      overflowX: 'clip',
    },
    [SM_MEDIA_QUERY]: {
      gridTemplateColumns: '1fr 10fr',
    },
    [MD_MEDIA_QUERY]: {
      gap: spacing[2],
    },
  },
}));

export default useHubSpotStyles;
